import { Box } from '@material-ui/core';
import { PurchaseCountry } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Text } from './Text';

interface PurchaseCountryWithFlagProps {
  purchaseCountry: PurchaseCountry;
}

export const PurchaseCountryWithFlag = ({ purchaseCountry }: PurchaseCountryWithFlagProps) => {
  return (
    <Box display={'inline-flex'} alignItems={'center'}>
      <Text tId={purchaseCountry} />
      <img
        src={`https://cdn.nemuru.com/assets/icons/countries/alpha_3/${purchaseCountry.toLowerCase()}.svg`}
        style={{ height: 18, width: 18, paddingLeft: '8px' }}
      />
    </Box>
  );
};
